import { Badge, BadgeVariant } from '../../../../../../components/atoms/badge/badge';
import {
  STATUS_VENDA_LABEL,
  StatusVenda,
} from '../../../../../../types/cliente-venda';

const variantByStatus: Record<StatusVenda, BadgeVariant> = {
  [StatusVenda.PENDING]: 'warning',
  [StatusVenda.PAID]: 'success',
  [StatusVenda.REFUSED]: 'danger',
  [StatusVenda.CANCELED]: 'neutral',
  [StatusVenda.CHARGEBACK]: 'danger',
  [StatusVenda.REFUND]: 'warning',
  [StatusVenda.FAILED]: 'danger',
  [StatusVenda.TESTE]: 'neutral',
  [StatusVenda.REFUND_COMPLETED]: 'neutral',
};

interface Props {
  status: StatusVenda | null;
  descricao?: string | null;
}

export const VendaStatusBadge = ({ status, descricao }: Props) => {
  if (status == null) return <Badge variant="neutral">—</Badge>;
  return (
    <Badge variant={variantByStatus[status] ?? 'neutral'}>
      {descricao ?? STATUS_VENDA_LABEL[status] ?? `#${status}`}
    </Badge>
  );
};
